module.exports = __webpack_public_path__ + "fonts/Godiva-Reguler.9973d8b.woff2";